define("auth/components/signup-form", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-changeset", "ember-changeset-validations", "ember-concurrency", "later/config/environment", "later/utils/constants", "later/utils/constants/segment-events", "later/utils/create-user", "later/utils/load-script", "later/validations/user", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberChangeset, _emberChangesetValidations, _emberConcurrency, _environment, _constants, _segmentEvents, _createUser, _loadScript, _user, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-changeset",0,"ember-changeset-validations",0,"ember-concurrency",0,"later/config/environment",0,"later/utils/constants",0,"later/utils/constants/segment-events",0,"later/utils/create-user",0,"later/utils/load-script",0,"later/validations/user",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Create an Account }}
  <div class="tSU--container" data-test-id="signup-form">
    {{#if this.isCampaignSignup}}
      <div class="tSU--container__row">
        <div class="tPA--card tPA--card--accentHighlight tPA--card--campaignLogin cCC--card">
          <div class="cCC--card__body">
            <div class="cCC--info__detail u--text--black u--m__b__xs">
              <p class="u--text--md u--text--bold u--m__t__0 u--m__b__xs">{{t "influencers.login.banner.header"}}</p>
              <p class="u--m__b__0">
                {{t "influencers.login.banner.description"}}
                <a href="https://help.later.com/hc/articles/26166001175447" rel="noopener noreferrer" target="_blank">
                  {{t "shared_phrases.learn_more"}}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    {{/if}}
    {{! Cards }}
    <div class="tSU--container__row">
      {{! Card }}
  
      {{#if this.isCampaignSignup}}
        <CampaignDetails @campaign={{this.campaign}} />
      {{/if}}
  
      <div class="tSU--card">
        <h1 class="tSU--card__title">{{this.title}}</h1>
        {{#if this.isCampaignSignup}}
          <p class="tSU--card__subTitle u--m__b__0">
            {{html-safe (t "authorization.sign_up_campaign_form.subtitle" brand=this.campaign.brand_name)}}
          </p>
        {{else}}
          <p class="tSU--card__subTitle u--m__b__0">{{t "authorization.create_account.sub_title"}}</p>
        {{/if}}
  
        {{! Form Objects }}
        <form class="u--p__t__lg" {{on "submit" (perform this.createUser)}}>
          {{! Name }}
          <div class="o--formWrapper--lg dd-privacy-mask-user-input">
            <label for="name">{{t "authorization.create_account.label_name"}}</label>
            <Input
              @value={{this.newUserChangeset.name}}
              class="form-control o--form__input qa--signup_name_input"
              id="name"
              placeholder={{t "authorization.create_account.placeholder_name"}}
              {{autofocus}}
            />
          </div>
          {{! Email }}
          <div class="o--formWrapper--lg dd-privacy-mask-user-input">
            <label id="email">{{t "shared_words.email"}}</label>
            <Input
              @type="email"
              @value={{this.newUserChangeset.email}}
              class="form-control o--form__input qa--signup_email_input"
              id="email"
              placeholder={{t "authorization.create_account.placeholder_email"}}
              {{on "focus" this.resetErrors}}
            />
          </div>
  
          {{! Password }}
          <Shared::Credentials::PasswordInput
            @dataTestID="signup-password-input"
            @password={{this.newUserChangeset.password}}
            @qaClassName="signup_password_input"
            {{on "focus" this.resetErrors}}
          />
  
          {{! Password Confirmation }}
          <div class="o--formWrapper--lg">
            <label for="password-confirm">{{t "authorization.create_account.label_password_confirm"}}</label>
            <Input
              @type="password"
              @value={{this.passwordConfirmation}}
              class="form-control o--form__input qa--signup_password_confirm_input"
              id="password-confirm"
              placeholder={{t "authorization.create_account.placeholder_password_confirm"}}
              {{on "focus" this.resetErrors}}
            />
          </div>
  
          {{#if this.passwordMismatchError}}
            <p class="u--text--danger u--m__b__xs">
              {{svg-jar "warning" class="o--icon u--m__r__xs"}}
              {{this.passwordMismatchError}}
            </p>
          {{/if}}
  
          {{#if this.showErrors}}
            {{#if (is-present this.errors)}}
              {{#each this.errors as |error|}}
                <p class="u--text--danger u--m__b__xs">
                  {{svg-jar "warning" class="o--icon u--m__r__xs"}}
                  {{html-safe error.validation}}
                </p>
              {{/each}}
            {{else if this.serverError}}
              <p class="u--text--danger u--m__b__xs">
                {{svg-jar "warning" class="o--icon u--m__r__xs"}}
                {{html-safe this.serverError}}
              </p>
            {{/if}}
          {{/if}}
  
          {{#if this.requiresExpressConsent}}
            <div class="o--form__checkbox" data-test-id="express-consent-checkbox">
              <label class="o--checkbox__label">
                <Input @checked={{this.expressConsent}} @type="checkbox" />
                {{t "authorization.create_account.express_consent"}}
              </label>
            </div>
          {{/if}}
  
          <div class="o--formSubmit">
            <Shared::Ui::Button
              @additional="block"
              @promise={{this.createUser}}
              @runningText={{t "shared_phrases.please_wait"}}
              @size="large"
              @text={{t "authorization.create_account.page_title"}}
              class="qa--signup_continue_button"
              type="submit"
            />
          </div>
        </form>
  
        {{! Feature Promo Section - Mobile Only }}
        {{#if this.isSignupFromLinkinbio}}
          <section class="tSU--promoLib">
            <p class="tSU--promoLib__title u--text--bold u--text--md">
              {{t "authorization.create_account_banner.title_linkinbio_only"}}
            </p>
          </section>
        {{else}}
          {{#unless this.isMavrckCreator}}
            <section class="u--m__b tSU--promo u--hide--mobile">
              <p class="u--text--base">{{t "authorization.create_account.promo.title"}}</p>
              <div class="tSU--promo__list u--m__t__md u--p__lr__md">
                <div class="tSU--promo__listItem">
                  <span>{{svg-jar "calendar" class="o--icon o--icon--lg o--icon--hl u--m__b__xs"}}</span>
                  <span class="u--text--base u--text--hl">
                    {{t "authorization.create_account.promo.content_scheduler"}}
                  </span>
                </div>
                <div class="tSU--promo__listItem">
                  <span>{{svg-jar "linkin-bio" class="o--icon o--icon--lg o--icon--hl u--m__b__xs"}}</span>
                  <span class="u--text--base u--text--hl">
                    {{t "authorization.create_account.promo.linkinbio_page_builder"}}
                  </span>
                </div>
                <div class="tSU--promo__listItem">
                  <span>{{svg-jar "collabs" class="o--icon o--icon--lg o--icon--hl u--m__b__xs"}}</span>
                  <span class="u--text--base u--text--hl">{{t "authorization.create_account.promo.creator_tools"}}</span>
                </div>
              </div>
            </section>
          {{/unless}}
        {{/if}}
        <p class="u--text--center u--m__b__lg u--m__t">
          {{t "authorization.already_have_an_account"}}
          {{#if this.isCampaignSignup}}
            <LinkTo @route="campaign.login" class="u--p__l__xs qa--logIn_link">
              {{t "authorization.sign_in"}}
            </LinkTo>
          {{else}}
            <LinkTo @route="login" class="u--p__l__xs qa--logIn_link">
              {{t "authorization.sign_in"}}
            </LinkTo>
          {{/if}}
        </p>
  
        {{#unless this.requiresExpressConsent}}
          <p class="u--text--light u--text--sm u--m__t__lg" data-test-id="opt-in-text">
            {{t "authorization.create_account.opt_in"}}
          </p>
        {{/unless}}
        <p class="u--text--light u--text--sm">
          {{t "authorization.create_account.agreement"}}
          <Shared::Link @href="https://later.com/terms/" class="u--text--light u--text--underline">
            {{t "authorization.create_account.terms"}}
          </Shared::Link>
          {{t "authorization.create_account.and"}}
          <Shared::Link @href="https://later.com/privacy/" class="u--text--light u--text--underline">
            {{t "authorization.create_account.privacy"}}
          </Shared::Link>
        </p>
      </div>
  
      {{#unless this.isCampaignSignup}}
        {{#if this.isMavrckCreator}}
          <div class="tSU--card tSU--card--mavrck">
            <div class="tSU--card--mavrck--description">
              <p class="u--text--bold u--text--lg">{{t "authorization.create_account_banner.creator_prompt"}}</p>
              <p class="u--text--md">{{t "authorization.create_account_banner.creator_description"}}</p>
            </div>
          </div>
        {{else if this.isSignupFromLinkinbio}}
          <div class="tSU--card tSU--card--linkinbio">
            <p class="tSU--card__title--featured tSU--highlight u--text--bold">
              {{t "authorization.create_account_banner.title_linkinbio_only"}}
            </p>
          </div>
        {{else}}
          <div class="tSU--card tSU--card--testimonial">
            {{!-- <p class="u--text--sm u--m__b__xs u--text--bold">{{t "authorization.create_account_banner.label"}}</p> --}}
            <p class="tSU--card__title--featured tSU--highlight u--text--bold">
              {{t "authorization.create_account_banner.title_linkinbio"}}
            </p>
            {{! <object type="image/svg+xml" data="/assets/images/logos/logos-group.svg" class="tSU--card--testimonial__logos"></object> }}
            <div class="tSU--card--testimonial__description u--text--center">
              <p class="u--text--italic">{{t "authorization.create_account_banner.testimonial"}}</p>
              <p class="u--text--bold u--m__b__0">{{t "authorization.create_account_banner.testimonial_author"}}</p>
              <p class="u--text--bold">{{t "authorization.create_account_banner.testimonial_company"}}</p>
            </div>
          </div>
        {{/if}}
      {{/unless}}
    </div>
  
    {{#if this.showMobileMavrck}}
      <div class="tSU--card tSU--card--mavrck--mob">
        <div class="tSU--card--mavrck--description">
          <p class="u--text--bold u--text--lg">{{t "authorization.create_account_banner.creator_prompt"}}</p>
          <p class="u--text--md">{{t "authorization.create_account_banner.creator_description"}}</p>
        </div>
      </div>
    {{/if}}
  
  </div>
  */
  {
    "id": "eZ5tgMrU",
    "block": "[[[10,0],[14,0,\"tSU--container\"],[14,\"data-test-id\",\"signup-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"isCampaignSignup\"]],[[[1,\"    \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tPA--card tPA--card--accentHighlight tPA--card--campaignLogin cCC--card\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCC--card__body\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"cCC--info__detail u--text--black u--m__b__xs\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md u--text--bold u--m__t__0 u--m__b__xs\"],[12],[1,[28,[35,1],[\"influencers.login.banner.header\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"influencers.login.banner.description\"],null]],[1,\"\\n              \"],[10,3],[14,6,\"https://help.later.com/hc/articles/26166001175447\"],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"shared_phrases.learn_more\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"tSU--container__row\"],[12],[1,\"\\n\"],[1,\"\\n\"],[41,[30,0,[\"isCampaignSignup\"]],[[[1,\"      \"],[8,[39,2],null,[[\"@campaign\"],[[30,0,[\"campaign\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n      \"],[10,\"h1\"],[14,0,\"tSU--card__title\"],[12],[1,[30,0,[\"title\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"isCampaignSignup\"]],[[[1,\"        \"],[10,2],[14,0,\"tSU--card__subTitle u--m__b__0\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[[28,[37,1],[\"authorization.sign_up_campaign_form.subtitle\"],[[\"brand\"],[[30,0,[\"campaign\",\"brand_name\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,2],[14,0,\"tSU--card__subTitle u--m__b__0\"],[12],[1,[28,[35,1],[\"authorization.create_account.sub_title\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[1,\"      \"],[11,\"form\"],[24,0,\"u--p__t__lg\"],[4,[38,4],[\"submit\",[28,[37,5],[[30,0,[\"createUser\"]]],null]],null],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper--lg dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,\"for\",\"name\"],[12],[1,[28,[35,1],[\"authorization.create_account.label_name\"],null]],[13],[1,\"\\n          \"],[8,[39,6],[[24,0,\"form-control o--form__input qa--signup_name_input\"],[24,1,\"name\"],[16,\"placeholder\",[28,[37,1],[\"authorization.create_account.placeholder_name\"],null]],[4,[38,7],null,null]],[[\"@value\"],[[30,0,[\"newUserChangeset\",\"name\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper--lg dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,1,\"email\"],[12],[1,[28,[35,1],[\"shared_words.email\"],null]],[13],[1,\"\\n          \"],[8,[39,6],[[24,0,\"form-control o--form__input qa--signup_email_input\"],[24,1,\"email\"],[16,\"placeholder\",[28,[37,1],[\"authorization.create_account.placeholder_email\"],null]],[4,[38,4],[\"focus\",[30,0,[\"resetErrors\"]]],null]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"newUserChangeset\",\"email\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[1,\"        \"],[8,[39,8],[[4,[38,4],[\"focus\",[30,0,[\"resetErrors\"]]],null]],[[\"@dataTestID\",\"@password\",\"@qaClassName\"],[\"signup-password-input\",[30,0,[\"newUserChangeset\",\"password\"]],\"signup_password_input\"]],null],[1,\"\\n\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper--lg\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,\"for\",\"password-confirm\"],[12],[1,[28,[35,1],[\"authorization.create_account.label_password_confirm\"],null]],[13],[1,\"\\n          \"],[8,[39,6],[[24,0,\"form-control o--form__input qa--signup_password_confirm_input\"],[24,1,\"password-confirm\"],[16,\"placeholder\",[28,[37,1],[\"authorization.create_account.placeholder_password_confirm\"],null]],[4,[38,4],[\"focus\",[30,0,[\"resetErrors\"]]],null]],[[\"@type\",\"@value\"],[\"password\",[30,0,[\"passwordConfirmation\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"passwordMismatchError\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--danger u--m__b__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,9],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n            \"],[1,[30,0,[\"passwordMismatchError\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showErrors\"]],[[[41,[28,[37,10],[[30,0,[\"errors\"]]],null],[[[42,[28,[37,12],[[28,[37,12],[[30,0,[\"errors\"]]],null]],null],null,[[[1,\"              \"],[10,2],[14,0,\"u--text--danger u--m__b__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n                \"],[1,[28,[35,3],[[30,1,[\"validation\"]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[1]],null]],[]],[[[41,[30,0,[\"serverError\"]],[[[1,\"            \"],[10,2],[14,0,\"u--text--danger u--m__b__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,9],[\"warning\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n              \"],[1,[28,[35,3],[[30,0,[\"serverError\"]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]],null]],[]]]],[]],null],[1,\"\\n\"],[41,[30,0,[\"requiresExpressConsent\"]],[[[1,\"          \"],[10,0],[14,0,\"o--form__checkbox\"],[14,\"data-test-id\",\"express-consent-checkbox\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,0,\"o--checkbox__label\"],[12],[1,\"\\n              \"],[8,[39,6],null,[[\"@checked\",\"@type\"],[[30,0,[\"expressConsent\"]],\"checkbox\"]],null],[1,\"\\n              \"],[1,[28,[35,1],[\"authorization.create_account.express_consent\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[10,0],[14,0,\"o--formSubmit\"],[12],[1,\"\\n          \"],[8,[39,13],[[24,0,\"qa--signup_continue_button\"],[24,4,\"submit\"]],[[\"@additional\",\"@promise\",\"@runningText\",\"@size\",\"@text\"],[\"block\",[30,0,[\"createUser\"]],[28,[37,1],[\"shared_phrases.please_wait\"],null],\"large\",[28,[37,1],[\"authorization.create_account.page_title\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isSignupFromLinkinbio\"]],[[[1,\"        \"],[10,\"section\"],[14,0,\"tSU--promoLib\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"tSU--promoLib__title u--text--bold u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"authorization.create_account_banner.title_linkinbio_only\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[51,[30,0,[\"isMavrckCreator\"]]],[[[1,\"          \"],[10,\"section\"],[14,0,\"u--m__b tSU--promo u--hide--mobile\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--base\"],[12],[1,[28,[35,1],[\"authorization.create_account.promo.title\"],null]],[13],[1,\"\\n            \"],[10,0],[14,0,\"tSU--promo__list u--m__t__md u--p__lr__md\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"tSU--promo__listItem\"],[12],[1,\"\\n                \"],[10,1],[12],[1,[28,[35,9],[\"calendar\"],[[\"class\"],[\"o--icon o--icon--lg o--icon--hl u--m__b__xs\"]]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"u--text--base u--text--hl\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"authorization.create_account.promo.content_scheduler\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"tSU--promo__listItem\"],[12],[1,\"\\n                \"],[10,1],[12],[1,[28,[35,9],[\"linkin-bio\"],[[\"class\"],[\"o--icon o--icon--lg o--icon--hl u--m__b__xs\"]]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"u--text--base u--text--hl\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"authorization.create_account.promo.linkinbio_page_builder\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"tSU--promo__listItem\"],[12],[1,\"\\n                \"],[10,1],[12],[1,[28,[35,9],[\"collabs\"],[[\"class\"],[\"o--icon o--icon--lg o--icon--hl u--m__b__xs\"]]]],[13],[1,\"\\n                \"],[10,1],[14,0,\"u--text--base u--text--hl\"],[12],[1,[28,[35,1],[\"authorization.create_account.promo.creator_tools\"],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"      \"],[10,2],[14,0,\"u--text--center u--m__b__lg u--m__t\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.already_have_an_account\"],null]],[1,\"\\n\"],[41,[30,0,[\"isCampaignSignup\"]],[[[1,\"          \"],[8,[39,15],[[24,0,\"u--p__l__xs qa--logIn_link\"]],[[\"@route\"],[\"campaign.login\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,1],[\"authorization.sign_in\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,15],[[24,0,\"u--p__l__xs qa--logIn_link\"]],[[\"@route\"],[\"login\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,1],[\"authorization.sign_in\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"requiresExpressConsent\"]]],[[[1,\"        \"],[10,2],[14,0,\"u--text--light u--text--sm u--m__t__lg\"],[14,\"data-test-id\",\"opt-in-text\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"authorization.create_account.opt_in\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,2],[14,0,\"u--text--light u--text--sm\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.create_account.agreement\"],null]],[1,\"\\n        \"],[8,[39,16],[[24,0,\"u--text--light u--text--underline\"]],[[\"@href\"],[\"https://later.com/terms/\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,1],[\"authorization.create_account.terms\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[1,[28,[35,1],[\"authorization.create_account.and\"],null]],[1,\"\\n        \"],[8,[39,16],[[24,0,\"u--text--light u--text--underline\"]],[[\"@href\"],[\"https://later.com/privacy/\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,1],[\"authorization.create_account.privacy\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[51,[30,0,[\"isCampaignSignup\"]]],[[[41,[30,0,[\"isMavrckCreator\"]],[[[1,\"        \"],[10,0],[14,0,\"tSU--card tSU--card--mavrck\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"tSU--card--mavrck--description\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--text--lg\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.creator_prompt\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.creator_description\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSignupFromLinkinbio\"]],[[[1,\"        \"],[10,0],[14,0,\"tSU--card tSU--card--linkinbio\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"tSU--card__title--featured tSU--highlight u--text--bold\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"authorization.create_account_banner.title_linkinbio_only\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"tSU--card tSU--card--testimonial\"],[12],[1,\"\\n\"],[1,\"          \"],[10,2],[14,0,\"tSU--card__title--featured tSU--highlight u--text--bold\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"authorization.create_account_banner.title_linkinbio\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"tSU--card--testimonial__description u--text--center\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--italic\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.testimonial\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold u--m__b__0\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.testimonial_author\"],null]],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--bold\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.testimonial_company\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showMobileMavrck\"]],[[[1,\"    \"],[10,0],[14,0,\"tSU--card tSU--card--mavrck--mob\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tSU--card--mavrck--description\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--text--lg\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.creator_prompt\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md\"],[12],[1,[28,[35,1],[\"authorization.create_account_banner.creator_description\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[13]],[\"error\"],false,[\"if\",\"t\",\"campaign-details\",\"html-safe\",\"on\",\"perform\",\"input\",\"autofocus\",\"shared/credentials/password-input\",\"svg-jar\",\"is-present\",\"each\",\"-track-array\",\"shared/ui/button\",\"unless\",\"link-to\",\"shared/link\"]]",
    "moduleName": "auth/components/signup-form.hbs",
    "isStrictMode": false
  });
  let SignupFormComponent = _exports.default = (_class = class SignupFormComponent extends _component2.default {
    get isValid() {
      this.newUserChangeset.validate();
      return this.newUserChangeset.isValid && this.newUserChangeset.password === this.passwordConfirmation;
    }
    get errors() {
      return this.newUserChangeset.errors;
    }
    get passwordMismatchError() {
      if (this.showPasswordMismatchError && this.newUserChangeset.password !== this.passwordConfirmation) {
        return this.intl.t('authorization.create_account.password_mismatch');
      }
      return undefined;
    }
    get requiresExpressConsent() {
      if (!this.newUserChangeset?.timeZoneIdentifier) {
        return false;
      }
      return _constants.EU_TZ_LIST.includes(this.newUserChangeset.timeZoneIdentifier);
    }
    get isSignupFromLinkinbio() {
      return this.onboarding.isSignupFromLinkinbio;
    }
    get isMavrckCreator() {
      return this.args.utmSource === 'mavrck';
    }
    get isMobile() {
      return this.userAgent.device.isMobile;
    }
    get showMobileMavrck() {
      return this.isMobile && this.isMavrckCreator;
    }
    get campaign() {
      return this.args.campaign;
    }
    get isCampaignSignup() {
      return !!this.campaign;
    }
    get title() {
      if (this.isCampaignSignup) {
        return this.intl.t('authorization.sign_up_campaign_form.title');
      }
      return this.intl.t('authorization.create_account.title');
    }
    constructor(owner, args) {
      super(owner, args);
      // eslint-disable-next-line ember/no-unused-services
      _initializerDefineProperty(this, "auth", _descriptor, this);
      // used in create-user util
      _initializerDefineProperty(this, "onboarding", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      // eslint-disable-next-line ember/no-unused-services
      _initializerDefineProperty(this, "segmentEvents", _descriptor5, this);
      // used in create-user util
      _initializerDefineProperty(this, "session", _descriptor6, this);
      _initializerDefineProperty(this, "store", _descriptor7, this);
      _initializerDefineProperty(this, "segment", _descriptor8, this);
      _initializerDefineProperty(this, "userAgent", _descriptor9, this);
      _initializerDefineProperty(this, "newUserChangeset", _descriptor10, this);
      _initializerDefineProperty(this, "serverError", _descriptor11, this);
      _initializerDefineProperty(this, "showErrors", _descriptor12, this);
      _initializerDefineProperty(this, "showPasswordMismatchError", _descriptor13, this);
      _initializerDefineProperty(this, "expressConsent", _descriptor14, this);
      _initializerDefineProperty(this, "passwordConfirmation", _descriptor15, this);
      _defineProperty(this, "createUser", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          this.newUserChangeset.validate();
          if (!this.isValid) {
            this.showErrors = true;
            this.showPasswordMismatchError = this.newUserChangeset.password !== this.passwordConfirmation;
            return;
          }
          try {
            yield _createUser.createUser.call(this, event);
          } catch (error) {
            if (error?.message.toLowerCase().includes('another later account')) {
              this.segment.track('signup-attempt-already-exists');
            }
            this.showErrors = true;
            this.serverError = error.message;
          }
        }
      }), null, "createUser", "drop"));
      const user = this.store.createRecord('user', {
        timeZone: this.args.userTimeZone,
        timeZoneIdentifier: this.args.userTimeZone
      });
      this.newUserChangeset = (0, _emberChangeset.Changeset)(user, (0, _emberChangesetValidations.default)(_user.default), _user.default);

      // Note: Google script to load recaptcha for signup
      // https://developers.google.com/recaptcha/docs/v3
      (0, _loadScript.default)(`https://www.google.com/recaptcha/api.js?render=${_environment.default.APP.googleRecaptchaSiteKey}`);

      // This prevents redirecting back to the `attemptedTransition` stored by ember-simple-auth.
      // Generally, we want to require new users to go through the onboarding flow.
      // https://ember-simple-auth.com/api/classes/SessionService.html
      this.session.set('attemptedTransition', undefined);
    }
    goToCalendar() {
      this.router.transitionTo('cluster.schedule.calendar');
    }
    resetErrors() {
      this.showErrors = false;
      this.showPasswordMismatchError = false;
      this.serverError = undefined;
    }
    trackCampaignUserSignup() {
      if (this.campaign) {
        this.segment.track(_segmentEvents.SegmentEventTypes.SignedUpViaCampaign, {
          campaign_name: this.campaign.name,
          campaign_id: this.campaign.slug
        });
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "newUserChangeset", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "serverError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return undefined;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showErrors", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showPasswordMismatchError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "expressConsent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "passwordConfirmation", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "goToCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetErrors", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetErrors"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SignupFormComponent);
});